import React from 'react';
import styled from 'styled-components';
// components
import { Loading } from 'components/Loading';

const LoadingContainer = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  & > div {
    transform: scale(2);
  }
`;

const BasicLoader = ({ className, ...props }) => (
  <LoadingContainer className={className}>
    <Loading {...props} />
  </LoadingContainer>
);

export default BasicLoader;
